import { getAccessTokenJwtHeader } from '@/assets/src/amplify/helpers';
import { getJson, postJson, deleteJson } from '@/assets/src/json_loader';
import { API_URL } from '@/assets/src/configs';

export interface ProductAccessPeriod {
  id?: number;
  account_group_id: number;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
  product_type: string;
  source?: string;
  quantity: number;
  price: number;
  currency: string;
  period_start: string;
  period_end: string;
  description: string;
}

const productAccessPeriodEndpoint = `${API_URL}/private/productaccessperiod`;
const listProductAccessPeriodsEndpoint = `${API_URL}/private/productaccessperiods`;
const productTypesEndpoint = `${API_URL}/private/productaccessperiods_types`;

export class ProductAccessClient {
  public async addProductAccessPeriod(input: ProductAccessPeriod): Promise<void> {
    const headers = await getAccessTokenJwtHeader();
    await postJson(productAccessPeriodEndpoint, input, headers);
  }

  public async getProductAccessPeriods(cognitoID: string): Promise<ProductAccessPeriod[]> {
    const headers = await getAccessTokenJwtHeader();
    const endpoint = `${listProductAccessPeriodsEndpoint}/${cognitoID}`;
    const response: any = await getJson(endpoint, headers);

    return response.product_access_periods;
  }

  public async deleteProductAccessPeriod(id: number): Promise<void> {
    const headers = await getAccessTokenJwtHeader();
    const endpoint = `${productAccessPeriodEndpoint}/${id}`;
    await deleteJson(endpoint, headers);
  }

  public async getProductTypes(): Promise<string[]> {
    const headers = await getAccessTokenJwtHeader();
    const response: any = await getJson(productTypesEndpoint, headers);
    return response.product_types;
  }
}
